import Button from '@mui/material/Button';
import React from 'react';

interface FillButtonProps {
  name: string;
  onClick?: () => void; 
  disabled:any;
}

const FillButton: React.FC<FillButtonProps> = ({ name, onClick,disabled }) => {
  return (
    <div>
      <Button
        className='w-80 bg-customBlue'
        variant="contained"
        sx={{ textTransform: "none", borderRadius: "25px", 
          '&:hover': {
            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR_HOVER,
          },backgroundColor: process.env.REACT_APP_PRIMARY_COLOR, }}
        onClick={onClick}
        disabled={disabled}
        
      >
        {name}
      </Button>
    </div>
  );
};

export default FillButton;
